import type { ComponentNameAndModule } from '@sitecore-jss/sitecore-jss-angular';

const loadChildren = () =>
  import('./content.lazy.module').then((module) => module.ContentLazyModule);

const defineImport = (path: string) => ({
  path,
  loadChildren,
});

export const contentLazyImports: ComponentNameAndModule[] = [
  defineImport('FaqSection'),
  defineImport('ThreeTopTasksSection'),
  defineImport('FourTopTasksSection'),
  defineImport('Hero'),
  defineImport('HeroMinimal'),
  defineImport('HeroWithAppButtons'),
  defineImport('HeroWithAsset'),
  defineImport('HeroWithWidget'),
  defineImport('NotificationSection'),

  // TechDebt: Here for backwards compatibility, will be removed before closing ATL-2468
  defineImport('InformationBar'),
];
